/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditMentionsAuditMentionsMatchesGetQueryResponse, AuditMentionsAuditMentionsMatchesGetPathParams, AuditMentionsAuditMentionsMatchesGetQueryParams } from "../models/AuditMentionsAuditMentionsMatchesGet";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditMentionsAuditMentionsMatchesGet } from "../axios/auditMentionsAuditMentionsMatchesGet";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditMentionsAuditMentionsMatchesGetQueryKey = (mentionMatchId: AuditMentionsAuditMentionsMatchesGetPathParams["mentionMatchId"], params: AuditMentionsAuditMentionsMatchesGetQueryParams) => ["api-v2", { url: '/audit-mentions/v1/matches/:mentionMatchId', params: {mentionMatchId:mentionMatchId} }, ...(params ? [params] : [])] as const

export type AuditMentionsAuditMentionsMatchesGetQueryKey = ReturnType<typeof auditMentionsAuditMentionsMatchesGetQueryKey>

export function auditMentionsAuditMentionsMatchesGetQueryOptions(mentionMatchId: AuditMentionsAuditMentionsMatchesGetPathParams["mentionMatchId"], params: AuditMentionsAuditMentionsMatchesGetQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditMentionsAuditMentionsMatchesGetQueryKey(mentionMatchId, params)
        return queryOptions<AuditMentionsAuditMentionsMatchesGetQueryResponse, ResponseErrorConfig<Error>, AuditMentionsAuditMentionsMatchesGetQueryResponse, typeof queryKey>({
         enabled: !!(mentionMatchId&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditMentionsAuditMentionsMatchesGet(mentionMatchId, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a mention match by id.
 * @summary Get mention match
 * {@link /audit-mentions/v1/matches/:mentionMatchId}
 */
export function useAuditMentionsAuditMentionsMatchesGet<TData = AuditMentionsAuditMentionsMatchesGetQueryResponse, TQueryData = AuditMentionsAuditMentionsMatchesGetQueryResponse, TQueryKey extends QueryKey = AuditMentionsAuditMentionsMatchesGetQueryKey>(mentionMatchId: AuditMentionsAuditMentionsMatchesGetPathParams["mentionMatchId"], params: AuditMentionsAuditMentionsMatchesGetQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditMentionsAuditMentionsMatchesGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditMentionsAuditMentionsMatchesGetQueryKey(mentionMatchId, params)
         

         const query = useQuery({
          ...auditMentionsAuditMentionsMatchesGetQueryOptions(mentionMatchId, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}